export const styles = {
  dialog: {
    '& .MuiDialog-paper': {
      maxWidth: '600px',
      width: '100%',
      padding: '2em',
    },
  },
  formControl: {
    marginBottom: '1.5em',
    width: '100%',
  },
  uploadButton: {
    marginBottom: '1.5em',
  },
  countrySelect: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1em',
    marginTop: '1em',
    maxHeight: '400px',
    overflowY: 'auto',
  },
  globalActions: {
    marginBottom: '1em',
    borderBottom: '1px solid #eee',
    paddingBottom: '0.5em',
  },
  regionAccordion: {
    '&.MuiAccordion-root': {
      boxShadow: 'none',
      '&:before': {
        display: 'none',
      },
    },
  },
  regionHeader: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& .MuiFormControlLabel-root': {
      margin: 0,
      width: '100%',
    },
  },
  regionSummary: {
    '&.MuiAccordionSummary-root': {
      minHeight: '48px',
      padding: '0 8px',
      '&.Mui-expanded': {
        minHeight: '48px',
      },
    },
  },
  regionTitle: {
    fontWeight: 500,
    color: '#333',
    fontSize: '0.95rem',
  },
  countriesGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25em',
    paddingLeft: '0.5em',
    '& .MuiCheckbox-root': {
      color: '#1976d2',
      '&.Mui-checked': {
        color: '#1976d2',
      },
    },
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '1em',
    marginTop: '2em',
  },
  button: {
    borderRadius: '2em',
    padding: '0.5em 2em',
    textTransform: 'none',
  },
};